import { EmissionService } from 'app/services/cp/EmissionService';
import { CountUpUtil } from 'app/utils/countUpUtil';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import CountUp from 'react-countup';
import { toast } from 'react-toastify';
import DashboardLoading from "./DashboardLoading";
import { DashboardModuleProps } from "app/model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";
import { numberFormatter } from "app/utils/stringUtil";

export default function MonthlyImplementResult(props: Readonly<DashboardModuleProps>) {
  //Scope별 배출량
  const [scope1, setScope1] = useState(0);
  const [scope2, setScope2] = useState(0);
  const [scope3, setScope3] = useState(0);
  const [emsList, setEmsList] = useState<any>();
  const [scopUse, setScopUse] = useState<any>({ scopN1UseYn: "N", scopN2UseYn: "N", scopN3UseYn: "N" });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data1, setData1] = useState([
    {
      'kau': 0,
      'kcu': 0,
      'koc': 0
    }
  ]);

  const [data2, setData2] = useState([
    {
      'iKcu': 0,
      'iKou': 0
    }
  ]);

  const calculateTotal = (arr: any, prefix: any) => {
    if (arr && arr.length > 0) {
      return arr
        .filter((item: any) => findLabelByValue(item.emcrdNm).toUpperCase().startsWith(prefix.toUpperCase()))
        .reduce((total: any, item: any) => total + item.itmNqnt, 0);
    }
  };

  const findLabelByValue = (value: any) => {
    let label = '';
    const changedEmsList: any = transformEmsList(emsList);
    if (changedEmsList) {
      const item = changedEmsList.find((d: any) => d.value === value);
      label = item?.label ?? '';

    }
    return label;
  };

  const transformEmsList = (result: any) => {
    if (!result) {
      return null;
    }

    return result.map((item: any) => ({
      label: item.itmNm,
      value: item.isinCd
    }));
  }

  useEffect(() => {
    getBoardScope();
    getStaHolEmis();
    setIsLoading(false);
  }, [emsList]);

  useEffect(() => {
    EmissionService.getInstance()
      .getEmission2()
      .then(function (res) {
        const itemList = Array.from(
          new Set(
            res.data.data.map((item: any) =>
              JSON.stringify({
                itmNm: item.itmNm,
                isinCd: item.isinCd,
              })
            )
          )
        );
        const result: any = [];

        itemList.forEach((value: any) => {
          result.push(JSON.parse(value.toString()));
        });

        setEmsList(result);
      })
      .catch(() => toast.error(t('common.message.error.system')));
  }, []);

  function getStaHolEmis() {
    EmissionService.getInstance().getStaHolEmis2().then((response: any) => {

      if (response.data.result) {
        const data = response.data.data.contents;

        setData1([
          {
            'kau': calculateTotal(data, "KAU"),
            'kcu': calculateTotal(data, "KCU"),
            'koc': calculateTotal(data, "KOC")
          }]);
        setData2([
          {
            'iKcu': calculateTotal(data, "i-KCU"),
            'iKou': calculateTotal(data, "i-KOC"),
          }])
      }
    })
  }

  function getBoardScope() {
    EmissionService.getInstance()
      .getBoardScope()
      .then((response: any) => {
        if (response.data.statusCode) {

          const data = response.data.data;
          const scopUse = data.scopUse;

          let scope1 = 0;
          let scope2 = 0;
          let scope3 = 0;

          const listScope1 = data.listScope1;
          const listScope2 = data.listScope2;
          const listScope3 = data.listScope3;

          for (const element of listScope1) {
            scope1 += element["sumScope"];
          }

          for (const element of listScope2) {
            scope2 += element["sumScope"];
          }

          for (const element of listScope3) {
            scope3 += element["sumScope"];
          }

          setScope1(scope1);
          setScope2(scope2);
          setScope3(scope3);
          setScopUse(scopUse);

        } else {
          toast.error("데이터를 가져오는데 실패하였습니다.")
        }
      })
      .catch(() => {
        toast.error(t("common.message.error.system"));
      });
  }

  function convertNumber(number: any) {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
    // + ' tCO2eq';
  }

  return (
    <DashboardCard
      title="배출권 보유 현황"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/cp/emiss/management"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      <div className="sub-inner-flex1">
        <div className="row-col-gap2">
          <div className="box-solo">
            <div className="inner">
              <p>Scope1</p>
              <strong className="c-num">
                <CountUp
                  end={(scopUse?.scopN1UseYn === "Y" ? Number(scope1.toFixed(2)) : 0)}
                  duration={0.5}
                  decimals={CountUpUtil.getDecimal((scope1 ? Number(scope1.toFixed(2)) : 0))}
                  formattingFn={(value) => convertNumber(value)}
                >
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp> tCO₂eq
              </strong>
            </div>
          </div>
          <div className="box-solo">
            <div className="inner">
              <p>Scope2</p>
              <strong className="c-num">
                <CountUp
                  end={(scopUse?.scopN2UseYn === "Y" ? Number(scope2.toFixed(2)) : 0)}
                  duration={0.5}
                  decimals={CountUpUtil.getDecimal((scope2 ? Number(scope2.toFixed(2)) : 0))}
                  formattingFn={(value) => convertNumber(value)}
                >
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp> tCO₂eq
              </strong>
            </div>
          </div>
          <div className="box-solo">
            <div className="inner">
              <p>Scope3</p>
              <strong className="c-num">
                <CountUp
                  end={(scopUse?.scopN3UseYn === "Y" ? Number(scope3.toFixed(2)) : 0)}
                  duration={0.5}
                  decimals={CountUpUtil.getDecimal((scope3 ? Number(scope3.toFixed(2)) : 0))}
                  formattingFn={(value) => convertNumber(value)}
                >
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp> tCO₂eq
              </strong>
            </div>
          </div>
        </div>

        <p className="titT3 mg0">국내 배출권 보유</p>
        <div className="tbl-st2 responsive-table mg0">
          <table>
            <caption>국내 배출권 보유</caption>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th>KAU</th>
                <th>KCU</th>
                <th>KOC</th>
                <th>I-KCU</th>
                <th>I-KOU</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong className="bold">{numberFormatter((data1[0].kau ?? 0), 1)}</strong> tCO₂eq</td>
                <td><strong className="bold">{numberFormatter((data1[0].kcu ?? 0), 1)}</strong> tCO₂eq</td>
                <td><strong className="bold">{numberFormatter((data1[0].koc ?? 0), 1)}</strong> tCO₂eq</td>
                <td><strong className="bold">{numberFormatter((data2[0].iKcu ?? 0), 1)}</strong> tCO₂eq</td>
                <td><strong className="bold">{numberFormatter((data2[0].iKou ?? 0), 1)}</strong> tCO₂eq</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </DashboardCard>
  )
}

